import {
  initNotificationOverlayWebComponent,
  NotificationCountgroupData,
  NotificationOverlayElement,
} from "./notificationOverlay";

initNotificationOverlayWebComponent();
const template = document.createElement("template");
template.innerHTML = `
<style>
.fa-stack {
    position: relative;
    display: inline-block;
    width: 1.5em;
    line-height: 2em;
    vertical-align: middle;
}
.p1[data-count]:after {
    position: absolute;
    right: 20%;
    top: 8%;
    content: attr(data-count);
    font-size: 60%;
    padding: .2em;
    border-radius: 50%;
    line-height: 1em;
    color: white;
    background: #B94A48;
    opacity: 0.9;
    text-align: center;
    min-width: 1em;
}
.p1[data-count="0"]:after {
  display: none;
}
i {
  font-family: 'Font Awesome 5 Free';
  font-weight: 900;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}
span i::before {
  content: "\\f0f3";
  color: gray;
}
span.has-badge i::before {
  content: "\\f0f3";
  color: #0066A1;
}
.badge {
  position: relative;
  display: inline-block;
  text-align: left;
}
</style>
<div class="badge">
  <span class="p1 fa-stack fa-2x" data-count="0">
    <i></i>
  </span>
  <notification-overlay></notification-overlay>
</div>
`;
export class NotificationBadgeElement extends HTMLElement {
  private _shadowRoot: ShadowRoot;
  private _count: number;
  constructor() {
    super();
    this._shadowRoot = this.attachShadow({ mode: "open" });
    this._shadowRoot.appendChild(template.content.cloneNode(true));

    this._shadowRoot.addEventListener("click", this.showOverlay);
  }

  private setCount(count: number) {
    if (count > 0) {
      this._shadowRoot.querySelector("span.p1").classList.add("has-badge");
      this._shadowRoot.querySelector("span.p1").setAttribute("data-count", count.toString());
    } else {
      this._shadowRoot.querySelector("span.p1").classList.remove("has-badge");
      this._shadowRoot.querySelector("span.p1").removeAttribute("data-count");
    }
    this._count = count;
  }
  private showOverlay = (evt) => {
    if (this._count > 0) {
      let overlay = (this._shadowRoot.querySelector("notification-overlay") as NotificationOverlayElement);
      overlay.toggle();
    }
  }

  public set data(data: NotificationBadgeData) {
    this.setCount(data?.totalCount ?? 0);
    let overlay = (this._shadowRoot.querySelector("notification-overlay") as NotificationOverlayElement);
    overlay.data = data.groups ?? [];
  }
}

export interface NotificationBadgeData {
  totalCount: number;
  groups: NotificationCountgroupData[];
}

export function initNotificationBadgeWebComponent() {
  window.customElements.define("notification-badge", NotificationBadgeElement);
}
